import request from "@utils/request";

const SearchApiService = {
    /**
     * 保存 扣减纪录
     * @param data
     */
    saveAddEduction(data={}) {
        return request({
            url:  '/service/mg/fin/ddp/deduction-item/save',
            method: "POST",
            data
        });
    },
};

export default SearchApiService;
